export function truncate(string = '', limit = 60, ellipsis = true ) {
  const putEllipsis = ellipsis ? ' ...' : '';
  return (typeof string === "string" && string.length > limit) ? string.substring(0,limit) + putEllipsis : string;
}